// revit插件端初始化
import StorageUtils from './core/storageUtils'
import { InitRevitClient } from './core/revitUtils'

export const initRevit = function({ Vue, Store }, { softwareCode, softwareVersion, language }) {
  return new Promise((resolve) => {
    InitRevitClient().then(async(client) => {
      Vue.prototype.$revitClient = client
      if ((!softwareCode || !softwareVersion)) {
        const res = await client.GetDesktopInfo()
        const data = res.data || {}
        softwareCode = data.hostAppName
        softwareVersion = data.hostAppVersion
      }
      StorageUtils.sessionStorage.set('softwareCode', softwareCode)
      StorageUtils.sessionStorage.set('softwareVersion', softwareVersion)
      StorageUtils.sessionStorage.set('language', language)
      Store.commit('setSoftwareCode', softwareCode)
      Store.commit('setSoftwareVersion', softwareVersion)
      Store.commit('setLanguage', language)
      resolve()
    })
  })
}
